// extracted by mini-css-extract-plugin
module.exports = {"days":"n","additionalInfo":"o","hidden":"p","centerMenu":"q","logo":"r","social":"s","socialLink":"t"};